import { SessionUid } from "./base";

export type Color = "red" | "yellow" | "green" | "blue" | "black"
export type ColorClassName = "is-danger" | "is-warning" | "is-success" | "is-info" | "is-dark"
export type ColorTextClassName = "has-text-danger" | "has-text-warning" | "has-text-success" | "has-text-info" | "has-text-dark"

export type CategoryData = SessionUid & {
  title: string;
  description: string | null;
  color: Color;
  visible?: boolean;
  order?: string[]; // item uids
}

export const categoryTransform = (val: any): CategoryData => {
  // react-firebase-hooks calls transforms with `null` when the snapshot has no data.
  if (val == null) return val as unknown as CategoryData;
  return {
    ...val,
    color: transformColor(val.color),
  };
};

export function transformColor(color?: string): Color {
  switch (color) {
    case "is-danger":
    case "red":
      return "red";
    case "is-warning":
    case "yellow":
      return "yellow";
    case "is-success":
    case "green":
      return "green";
    case "is-info":
    case "blue":
      return "blue";
    default:
      return "black";
  }
}

export function colorToClassName(color?: Color): ColorClassName {
  switch (color) {
    case "red":
      return "is-danger";
    case "yellow":
      return "is-warning";
    case "green":
      return "is-success";
    case "blue":
      return "is-info";
    default:
      return "is-dark";
  }
}

export function colorToTextClassName(color?: Color): ColorTextClassName {
  switch (color) {
    case "red":
      return "has-text-danger";
    case "yellow":
      return "has-text-warning";
    case "green":
      return "has-text-success";
    case "blue":
      return "has-text-info";
    default:
      return "has-text-dark";
  }
}

export function colorToFill(color?: Color): string {
  switch (color) {
    case "red":
      return "hsl(12, 76%, 61%)";
    case "yellow":
      return "hsl(27, 87%, 67%)";
    case "green":
      return "hsl(173, 58%, 39%)";
    case "blue":
      return "hsl(203, 39%, 44%)";
    default:
      return "hsl(0, 0%, 71%)";
  }
}
